/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Payzentric
 */
export class Payzentric {
    /**
     *
     * @type {string}
     * @memberof Payzentric
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Payzentric
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Payzentric
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Payzentric
     */
    authkey: string;
    /**
     *
     * @type {string}
     * @memberof Payzentric
     */
    secretkey: string;
    /**
     *
     * @type {boolean}
     * @memberof Payzentric
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Payzentric
     */
    autoApprove: boolean;
}
